// @flow
import { Box, Dialog, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { ProviderAddressOutput, ProviderOutput } from '@coverright/data-access/types/medicare';
import { DoctorSelectionModalSearch } from './doctor-selection-modal-search';
import { ModalCloseButton } from '@coverright/ui/shared';
import { DoctorSelectionModalAddress } from './doctor-selection-modal-address';

type DoctorSelectionModalProps = {
  open: boolean;
  onClose: (doctor?: ProviderOutput) => void;
  doctor?: ProviderOutput;
  preferredDoctors?: ProviderOutput[];
  showSearchRadius?: boolean;
  zip: string;
  county: string;
};

export function DoctorSelectionModal(props: DoctorSelectionModalProps) {
  const [mode, setMode] = useState(Mode.Search);
  const [doctor, setDoctor] = React.useState<ProviderOutput & {specialty?: string}>();

  useEffect(() => {
    if (props.open) {
      if (props.doctor) {
        setMode(Mode.Address);
        setDoctor(props.doctor);
      }
    } else {
      setDoctor(undefined);
      setMode(Mode.Search)
    }
  }, [props.open, props.doctor]);

  const title = mode === Mode.Search ? 'Search and add your doctor' : 'Where do you normally see this doctor?';

  const handleDoctorSelect = (doctor: ProviderOutput) => {
    setDoctor({ ...doctor, addresses: [], specialty: doctor.addresses[0]?.specialty });
    setMode(Mode.Address)
  }

  const handleAddressesSelect = (addresses: ProviderAddressOutput[]) => {
    if (addresses && doctor) {
      props.onClose({
        ...doctor,
        addresses,
      });
    }
  }

  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={props.open}
      sx={{zIndex: 1501 }}
      onClose={() => props.onClose()}
    >
      <Box p={3}>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} mb={2}>
          <Typography variant={'h3'}>{title}</Typography>
          <ModalCloseButton onClick={() => props.onClose()} />
        </Stack>

        {mode === Mode.Search && (
          <DoctorSelectionModalSearch zip={props.zip}
                                      county={props.county}
                                      onSelect={handleDoctorSelect}
                                      showSearchRadius={props.showSearchRadius}
                                      filterOptionsFunc={op => !props.preferredDoctors?.some(d => d.npi === op.npi)} />
        )}

        {mode === Mode.Address && doctor && (
          <DoctorSelectionModalAddress addDoctorButtonLabel={props.doctor ? 'Update doctor' : 'Add doctor'}
                                       doctor={doctor}
                                       specialty={doctor.addresses[0]?.specialty || doctor.specialty}
                                       onCancel={() => {
                                         setDoctor(undefined);
                                         setMode(Mode.Search)
                                       }}
                                       onSelect={handleAddressesSelect} />
        )}
      </Box>

    </Dialog>
  );
}

enum Mode {
  Search,
  Address,
}

